import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { CSSProperties } from "react";

export type CustomRadioGroupInputOption = {
  id: number,
  label: string,
  style?: CSSProperties,
} | {
  id: string,
  label: string,
  style?: CSSProperties,
};

/**
 * CustomRadioGroupInput
 */

type Props = {
  name: string;
  required?: boolean;
  options: CustomRadioGroupInputOption[];
  disabled?: boolean;
  readOnly?: boolean;
  value: string | number | null;
  onValueChange: (value: string | number | null) => void
};

export const CustomRadioGroupInput = ({
  name,
  required,
  options,
  disabled,
  readOnly,
  value,
  onValueChange
}: Props) => {
  return (
    <FormControl size="small" className="flex flex-row" required={required}>
      <div className="flex flex-row items-center">
        <RadioGroup
          sx={{
            '&.MuiFormGroup-root.MuiRadioGroup-root': {
              '.MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementEnd': {
                '.MuiButtonBase-root.MuiRadio-root': {
                  '.PrivateSwitchBase-input': {
                    width: '0.15rem',
                    height: '0.15rem',
                  },
                  padding: '0.10rem',
                },
              },
            },
          }}
          aria-labelledby={`input-radio-group-${name as string}`}
          name={name}
          value={value ?? null}
          onChange={(e) => { if (!readOnly) onValueChange(e.target.value); }}
          row={true}>

          {options?.map(opt => (
            <FormControlLabel
              key={opt.id}
              className="text-black dark:text-white"
              value={opt.id}
              disabled={disabled}
              control={<Radio size="small" />}
              label={<span style={opt.style}>{opt.label}</span>}
            />
          ))}

        </RadioGroup>
      </div>
    </FormControl>
  );
}